import React, { useState } from 'react';
import './LoginModal.css';

const LoginModal = ({ onClose, onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(email, password);
    setEmail('');
    setPassword('');
  };

  return (
  <div className="login-modal-overlay">

    <div className="login-modal-container">

      <button
        className="close-login-modal"
        onClick={onClose}
      >
        ✕
      </button>

      <div className="login-header">

        <h2>Iniciar Sesión</h2>

        <p>
          Accede a tu cuenta de Club Oficial RP
        </p>

      </div>

      <form onSubmit={handleSubmit}>

        <div className="form-group">

          <label>Correo electrónico</label>

          <input
            type="email"
            placeholder="ejemplo@correo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

        </div>

        <div className="form-group">

          <label>Contraseña</label>

          <input
            type="password"
            placeholder="Tu contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

        </div>

        <a href="/" className="forgot-password">
          ¿Olvidaste tu contraseña?
        </a>

        <button
          type="submit"
          className="login-btn"
        >
          Iniciar sesión
        </button>

      </form>

      <div className="register-link">

        ¿No tienes una cuenta?

        <a href="/registro">
          Crear cuenta
        </a>

      </div>

    </div>

  </div>
);
};

export default LoginModal;
